module.exports = __webpack_public_path__ + "a17d279f/img/question-icon.06c20c5d.svg";